import React, { useEffect, useState } from 'react';
import { Col, Input, Row, Select, Radio, Button, Space } from 'antd';

import ProfilePreviewUploader from './ProfilePreviewUploader';
import FilePreviewUploader from '../FilePreviewUploader';

export default function Profile({ Form, getFieldValue, setFieldValue, fileList, setFileList }) {
	const [size, setSize] = useState();
	const [isLoading, setIsLoading] = useState(false);
	//   const [fileList, setFileList] = useState([]);
	return (
		<>
			<Row gutter={[16, 0]}>
				<Col sm={24} md={24}>
					<Form.Item label='Upload Logo' name='profilephoto'>
						{/* <ProfilePreviewUploader Form={Form} maxItems={10} /> */}
						<FilePreviewUploader Form={Form} maxItems={1} fileList={fileList} setFileList={setFileList} aspect={1 / 1} />
					</Form.Item>
				</Col>
				<Col sm={24} md={12}>
					<Form.Item
						label='Username'
						name='userName'
						rules={[
							{
								required: true,
								message: 'Username is required',
							},
						]}
					>
						<Input placeholder='Doe John' autoFocus />
					</Form.Item>
				</Col>
				<Col sm={24} md={12}>
					<Form.Item label='Name' name='name'>
						<Input placeholder='John ' autoFocus />
					</Form.Item>
				</Col>

				<Col sm={24} md={12}>
					<Form.Item
						label='Email'
						name='emailId'
						rules={[
							{
								required: true,
								message: 'Email is required',
							},
						]}
					>
						<Input placeholder='johndoe07@gmail.com' autoFocus />
					</Form.Item>
				</Col>
				<Col sm={24} md={12}>
					<Form.Item
						label='Mobile Number'
						name='mobile'
						rules={[
							{
								required: true,
								message: 'Mobile is required',
							},
						]}
					>
						<Input placeholder='9876543210' autoFocus />
					</Form.Item>
				</Col>

				<Col sm={24} md={12}>
					<Form.Item label=' Another Email' name='otherEmail'>
						<Input placeholder='johndoe07@gmail.com' autoFocus />
					</Form.Item>
				</Col>
				<Col sm={24} md={12}>
					<Form.Item label=' Another Mobile Number' name='otherMobile'>
						<Input placeholder='9876543210' autoFocus />
					</Form.Item>
				</Col>
				<Col sm={24} md={12}>
					<Form.Item label='Account Status' name='accountStatus'>
						<Radio.Group name='radiogroup' defaultValue={1}>
							<Radio value='Active'>Active</Radio>
							<Radio value='Deny'>Deny</Radio>
						</Radio.Group>
					</Form.Item>
				</Col>

				<Col sm={24} md={12}>
					<Form.Item label='Insider Type' name='InsiderType'>
						<Radio.Group name='radiogroup' defaultValue={1}>
							<Radio value='Pro'>Pro</Radio>
							<Radio value='Auditor'>Auditor</Radio>
							<Radio value='Traveler'>Traveler</Radio>
						</Radio.Group>
					</Form.Item>
				</Col>
			</Row>

			{/* <Space wrap>
        <Button size={size}>Cancel</Button>
        <Button type="primary" size={size}>
          Update Info
        </Button>
      </Space> */}
		</>
	);
}
